import { makeStyles, Theme } from '@material-ui/core/styles';
import { pink } from '@material-ui/core/colors';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    minWidth: 830,
    maxWidth: 1030,
  },
  mainButton: {
    marginRight: theme.spacing(1),
  },
  addModalRoot: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bodyScroll: {
    overflow: 'auto',
    height: 532,
    marginBottom: 20,
    paddingBottom: 5,
  },
  titleWrap: {
    paddingTop: 25,
    paddingLeft: 19,
  },
  modalPaper: {
    position: 'relative',
    width: 850,
    minHeight: 310,
    maxHeight: 800,
  },
  modalCloseButton: {
    position: 'absolute',
    right: 8,
    top: 10,
  },
  addModalTabRoot: {
    minWidth: '60px !important',
    marginLeft: 8,
    marginRight: 8,
  },
  addModalTabRootLeft: {
    minWidth: '60px !important',
    marginLeft: 15,
    marginRight: 8,
  },
  addModalTabWrapper: {
    textTransform: 'uppercase',
    fontSize: 14,
  },
  addModalTabContentWrap: {
    paddingTop: 0,
    paddingBottom: 15,
    top: 0,
    left: 0,
  },
  submitButtonProgress: {
    color: pink[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  bottomButtons: {
    width: '100%',
    flex: 1,
    justifyContent: 'flex-end',
  },
  paper: {
    padding: theme.spacing(3),
  },
  featuredCardsWrap: {
    marginTop: 19,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  featuredTitle: {
    width: '395px',
    marginBottom: 30,
  },
  featuredCardBox: {
    position: 'relative',
    backgroundColor: 'purple',
    width: 226,
    height: 127,
    borderRadius: 6,
    overflow: 'hidden',
    marginRight: 12,
    marginBottom: 14,
    boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.3)',
    userSelect: 'none',
  },
  featuredCardBottom: {
    display: 'flex',
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
    height: 33,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    paddingLeft: 11,
    paddingRight: 6,
    alignItems: 'center',
  },
  featuredCardType: {
    color: '#fff',
    height: 14,
    paddingLeft: 4,
    paddingRight: 4,
    fontSize: 9,
    textAlign: 'center',
  },
  featuredCardTypeSeason: {
    backgroundColor: '#158451',
  },
  featuredCardTypeStory: {
    backgroundColor: '#ff008a',
  },
  featuredCardTypeLink: {
    backgroundColor: '#4a90e2',
  },
  featuredCardTypeCollection: {
    backgroundColor: '#9013fe',
  },
  featuredCardTitle: {
    fontSize: '12px',
    color: '#ffffff',
    width: 170,
    marginLeft: 7,
    marginRight: 8,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  featuredCardButtons: {
    padding: 0,
    color: '#fff',
  },
  featuredCardEditButton: {
    marginRight: 8,
  },
  addFeaturedCard: {
    display: 'flex',
    backgroundColor: '#f0f0f0',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  addIconButton: {
    width: '100%',
    height: '100%',
    border: '0 none',
  },
  addIcon: {
    padding: 0,
    width: 100,
    height: 100,
    color: '#c8c8c8',
  },
  storyListWrap: {
    overflow: 'scroll',
    height: 'auto',
  },
  linkListWrap: {
    overflow: 'scroll',
    height: 421,
  },
  collectionListWrap: {
    overflow: 'auto',
  },
  storySearchWrap: {
    paddingTop: 15,
    paddingLeft: 15,
    paddingRight: 15,
  },
  collectionSearchWrap: {
    paddingTop: 15,
    paddingLeft: 15,
  },
  storyCoverImage: {
    width: '35px',
    height: '54px',
    objectFit: 'cover',
    backgroundColor: '#e8e8e8',
    marginRight: theme.spacing(2),
  },
  storyListItem: {
    borderBottom: '1px solid #e6e6e6',
  },
  storyListTitle: {
    flexBasis: '100%',
    color: '#222',
    fontSize: 13,
  },
  storyListWriter: {
    color: '#777',
    fontSize: 13,
  },
  linkCoverImage: {
    width: '90px',
    maxHeight: '50.6px',
    objectFit: 'cover',
    backgroundColor: '#e8e8e8',
    marginTop: 6,
    marginRight: theme.spacing(2),
    alignSelf: 'flex-start',
  },
  linkListItem: {
    borderBottom: '1px solid #e6e6e6',
  },
  linkListTitle: {
    flexBasis: '100%',
    color: '#212121',
    fontSize: 15,
    fontWeight: 500,
    paddingBottom: 4,
  },
  linkListUrl: {
    color: theme.palette.primary.main,
    fontSize: 14,
    paddingBottom: 2,
  },
  linkListLabel: {
    color: '#777',
    fontSize: 13,
  },
  linkListDesc: {
    color: '#212121',
    fontSize: 14,
  },

  collectionCoverImage: {
    width: '90px',
    maxHeight: '50.6px',
    objectFit: 'cover',
    backgroundColor: '#e8e8e8',
    marginTop: 6,
    marginRight: theme.spacing(2),
    alignSelf: 'flex-start',
  },
  collectionListItem: {
    borderBottom: '1px solid #e6e6e6',
  },
  collectionListTitle: {
    flexBasis: '100%',
    color: '#212121',
    fontSize: 15,
    fontWeight: 500,
    paddingBottom: 4,
  },
  collectionListUrl: {
    color: theme.palette.primary.main,
    fontSize: 14,
    paddingBottom: 2,
  },
  collectionListLabel: {
    color: '#777',
    fontSize: 13,
  },
  collectionListDesc: {
    color: '#212121',
    fontSize: 14,
  },
  collectionRow: {
    height: 55,
    cursor: 'pointer',
  },
  linkType: {
    position: 'absolute',
    fontSize: 13,
    color: '#212121',
    right: 20,
    top: 18,
  },
  detailWrap: {
    padding: '17px 0 17px 20px',
    height: 610,
  },
  detailTitle: {
    fontSize: '0.9375rem',
    marginBottom: 6,
  },
  detailValue: {
    fontSize: '14px',
    color: '#888888',
    paddingTop: '5px',
  },
  detailItem: {
    marginBottom: 23,
  },
  cancelRoot: {
    marginRight: 3,
  },
  cancelText: {
    letterSpacing: 0.5,
  },
  saveRoot: {
    width: 80,
  },
  featuredCardCoverImg: {
    width: '100%',
    objectFit: 'cover',
  },
  viewInfoItem: {
    fontSize: 14,
    color: '#888',
    paddingBottom: 30,
  },
  linkedWrap: {
    marginLeft: 16,
    height: 256,
    width: 490,
  },
  linkedItemBox: {
    width: 442,
    height: 134,
    border: 'solid 1px #dcdcdc',
    overflow: 'scroll',
  },
  titleEmphasize: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  linkedCurationsWrap: {
    border: 'solid 1px #dcdcdc',
    marginTop: 15,
    padding: '10px 14px',
  },
  linkedCurationItem: {
    marginBottom: 8,
  },
  linkedCurationTitle: {
    flex: '0 1 auto',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    marginRight: 5,
  },
  linkedCurationUserCount: {
    flex: '0 1 auto',
    color: '#4051b5',
  },
  capital: {
    textTransform: 'capitalize',
  },
}));

export default useStyles;
